import { render, staticRenderFns } from "./donut-chart.vue?vue&type=template&id=0475a8b0"
import script from "./donut-chart.vue?vue&type=script&lang=js"
export * from "./donut-chart.vue?vue&type=script&lang=js"
import style0 from "./donut-chart.vue?vue&type=style&index=0&id=0475a8b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports